import { useCallback } from "react";

import { useHref } from "react-router-dom";

import { useAppSelector } from "@/data/hooks";
import { selectIsLockDownExam } from "@/features/assignment";

/**
 *
 * @returns Whether the current assessment is a Respondus
 * LockDown Browser(LDB) exam and a function to exit the LDB
 * experience by navigating to the same page with a query
 * param that signals the respondus SDK to exit LDB mode.
 */
export function useRespondusLDB() {
  const exitLDBHref = useHref("?rldbxb=1");
  const isLDBExam = useAppSelector(selectIsLockDownExam);
  const isIpad = getIsIpad();
  const exitLDB = useCallback(
    () => window.open(exitLDBHref, "_self"),
    [exitLDBHref]
  );

  return {
    isLDBExam,
    isIpad,
    exitLDB,
  };
}

export function getIsIpad() {
  /*
   * Consider as iPad where the user agent includes "iPad" or where the user agent
   * includes "CMAC" and the device has more than 2 touch points (which is a characteristic of iPads).
   */
  if (
    navigator?.userAgent.includes("iPad") ||
    (navigator?.userAgent.includes("CMAC") && navigator.maxTouchPoints > 2)
  )
    return true;
  return false;
}
